/**
 * Builds an Enum from a list of strings.
 * Properties are not editable.
 *
 * Usage: new Enum('ONE', 'TWO', 'THREE')
 */
export default class Enum {
  constructor(...values) {
    values.forEach(value => {
      if (typeof value !== 'string') {
        throw new Error(`Enum helper: ${value} is not a string`);
      }

      Object.defineProperty(this, value, {
        value,
        writable: false,
        enumerable: true,
        configurable: false,
      });
    });
  }
}

/**
 * Builds an Enum from a list of strings.
 * Properties are not editable.
 *
 * Usage: new NamespacedEnum(
 *  'USER_INFO',
 *  ['ONE', 'TWO', 'THREE']
 * )
 */
export class NamespacedEnum {
  constructor(namespace, values) {
    if (typeof namespace !== 'string') {
      throw new Error('NamespacedEnum helper: namespace is not a string');
    }

    if (!Array.isArray(values)) {
      throw new Error('NamespacedEnum helper: "values" must be an array');
    }

    values.forEach(value => {
      if (typeof value !== 'string') {
        throw new Error(`NamespacedEnum helper: ${value} is not a string`);
      }

      Object.defineProperty(this, value, {
        value: `${namespace}:${value}`,
        writable: false,
        enumerable: true,
        configurable: false,
      });
    });
  }
}
